import React from "react";

export default function ShapedIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 25 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 3C18.1935 3 19.3381 3.47411 20.182 4.31802C21.0259 5.16193 21.5 6.30653 21.5 7.5V16.5C21.5 17.6935 21.0259 18.8381 20.182 19.682C19.3381 20.5259 18.1935 21 17 21H8C6.80653 21 5.66193 20.5259 4.81802 19.682C3.97411 18.8381 3.5 17.6935 3.5 16.5V7.5C3.5 6.30653 3.97411 5.16193 4.81802 4.31802C5.66193 3.47411 6.80653 3 8 3H17ZM8 1.5C6.4087 1.5 4.88258 2.13214 3.75736 3.25736C2.63214 4.38258 2 5.9087 2 7.5V16.5C2 18.0913 2.63214 19.6174 3.75736 20.7426C4.88258 21.8679 6.4087 22.5 8 22.5H17C18.5913 22.5 20.1174 21.8679 21.2426 20.7426C22.3679 19.6174 23 18.0913 23 16.5V7.5C23 5.9087 22.3679 4.38258 21.2426 3.25736C20.1174 2.13214 18.5913 1.5 17 1.5H8Z"
       />
    </svg>
  );
}
